import { useNumberFormatter } from "@react-aria/i18n";
import { useLabel } from "@react-aria/label";
import { clamp, filterDOMProps, mergeProps } from "@react-aria/utils";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
export function useProgressBar(props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$minValue = props.minValue,
      minValue = _props$minValue === void 0 ? 0 : _props$minValue,
      _props$maxValue = props.maxValue,
      maxValue = _props$maxValue === void 0 ? 100 : _props$maxValue,
      valueLabel = props.valueLabel,
      isIndeterminate = props.isIndeterminate,
      _props$formatOptions = props.formatOptions,
      formatOptions = _props$formatOptions === void 0 ? {
    style: 'percent'
  } : _props$formatOptions;
  var domProps = filterDOMProps(props, {
    labelable: true
  });

  var _useLabel = useLabel(_babelRuntimeHelpersEsmExtends({}, props, {
    labelElementType: 'span'
  })),
      labelProps = _useLabel.labelProps,
      fieldProps = _useLabel.fieldProps;

  value = clamp(value, minValue, maxValue);
  var percentage = (value - minValue) / (maxValue - minValue);
  var formatter = useNumberFormatter(formatOptions);

  if (!isIndeterminate && !valueLabel) {
    var valueToFormat = formatOptions.style === 'percent' ? percentage : value;
    valueLabel = formatter.format(valueToFormat);
  }

  return {
    progressBarProps: mergeProps(domProps, _babelRuntimeHelpersEsmExtends({}, fieldProps, {
      'aria-valuenow': isIndeterminate ? undefined : value,
      'aria-valuemin': minValue,
      'aria-valuemax': maxValue,
      'aria-valuetext': isIndeterminate ? undefined : valueLabel,
      role: 'progressbar'
    })),
    labelProps: labelProps
  };
}